import React, { useRef, useState } from 'react';
import { createWarehouseShipment, getWarehouseLabel } from '../api';
import Icon from './Icon';

const DIMENSIONS = [['dx', 'Длина, см'], ['dy', 'Ширина, см'], ['dz', 'Высота, см'], ['weight_gross', 'Вес брутто, г']];

export default function WarehouseShipmentPanel({ order, role = 'admin' }) {
  const shipment = order.shipments?.find(s => s.sellerOrderId == null && s.packingSnapshot?.mode === 'CONSOLIDATED');
  const [dimensions, setDimensions] = useState(shipment?.packingSnapshot?.places?.[0]?.physical_dims || {});
  const [created, setCreated] = useState(null);
  const [size, setSize] = useState('210x297');
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const operation = useRef(false);
  if (!shipment) return null;

  const ready = order.status === 'PAID' && ['collected', 'shipped'].includes(order.fulfillmentStatus);
  const requestId = created?.providerRequestId || shipment.providerRequestId;
  const validDimensions = DIMENSIONS.every(([key]) => Number.isInteger(Number(dimensions[key])) && Number(dimensions[key]) > 0);

  const create = async () => {
    if (operation.current) return;
    operation.current = true;
    setBusy(true);
    setMessage('');
    try {
      const { data } = await createWarehouseShipment(role, shipment.id, {
        dimensions: Object.fromEntries(DIMENSIONS.map(([key]) => [key, Number(dimensions[key])])),
        acknowledgePacked: ack,
        acknowledgeRealShipment: ack,
      });
      if (data.shipment?.providerRequestId) setCreated(data.shipment);
      else setMessage('Заявка ещё проверяется. Повторное нажатие проверит результат в Яндексе.');
    } catch (error) {
      setMessage(error.response?.data?.error || 'Не удалось получить ответ. Проверьте статус заявки.');
    } finally {
      operation.current = false;
      setBusy(false);
    }
  };

  const download = async () => {
    if (operation.current) return;
    operation.current = true;
    setBusy(true);
    setMessage('');
    try {
      const { data } = await getWarehouseLabel(role, shipment.id, size);
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'yandex-label.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch {
      setMessage('Яндекс пока не отдал этикетку. Повторите скачивание позже или откройте заявку в кабинете Яндекса.');
    } finally {
      operation.current = false;
      setBusy(false);
    }
  };

  return <section className="warehouse-shipment-panel">
    <h3><Icon name="box" />Общая посылка со склада</h3>
    <p>{shipment.packingSnapshot.unitsCount} шт. · одно грузоместо · Яндекс Доставка</p>
    {requestId ? <>
      <p>Заявка {requestId} · {created?.status || shipment.status}</p>
      {shipment.status !== 'CANCELLED' && <div className="warehouse-label-controls">
        <label>Формат этикетки <select value={size} onChange={e => setSize(e.target.value)} disabled={busy}>
          <option value="210x297">A4</option>
          <option value="100x150">100 × 150 мм</option>
        </select></label>
        <button type="button" className="btn btn-primary" disabled={busy} onClick={download}>{busy ? 'Получаем этикетку…' : 'Скачать этикетку со штрихкодом'}</button>
      </div>}
    </> : <>
      <p>Перед отправкой измерьте внешние габариты готовой коробки и её вес.</p>
      <div className="warehouse-dimensions">{DIMENSIONS.map(([key, label]) => <label key={key}>
        {label}
        <input type="number" min="1" step="1" value={dimensions[key] || ''} disabled={busy || !ready || !order.warehouseShippingEnabled} onChange={e => setDimensions(d => ({ ...d, [key]: e.target.value }))} />
      </label>)}</div>
      {!ready && <p className="buyer-notice">Создание заявки доступно после сборки и оплаты.</p>}
      {!order.warehouseShippingEnabled ? <p className="buyer-notice">Создание заявок доставки выключено.</p> : <>
        <label className="warehouse-ack"><input type="checkbox" checked={ack} disabled={!ready || busy} onChange={e => setAck(e.target.checked)} />Все товары собраны, упаковка измерена. Подтверждаю создание настоящей заявки в Яндексе.</label>
        <button type="button" className="btn btn-primary" disabled={!ready || !ack || busy || !validDimensions} onClick={create}>{busy ? 'Проверяем…' : 'Создать общую доставку'}</button>
      </>}
    </>}
    {message && <p role="status">{message}</p>}
    {shipment.itemOutcomes?.requiresReview && <p className="buyer-notice">Данные о выкупе требуют проверки оператором.</p>}
  </section>;
}
